<template>
  <transition name="modal">
    <div class="modal-mask">
      <a
        class="modal-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <img
          :src="asset('/images/close.png')"
          width="35px"
        > </a>

      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4 class="modal-title">
              About SECCA
            </h4>
          </div>

          <div class="modal-body about">
            <p>
              SECCA is a non-profit organization designed to support people with disabilities, in their efforts to learn about human relationships, sexuality and sexual health across the lifespan; as well as helping them to develop skills that will empower them to make informed choices, while acknowledging their own individual capacity to enhance the quality of their lives.
            </p>
          </div>

          <div class="modal-footer full-width">
            <div class="col-md-6">
              <a
                href="https://secca.org.au/"
                class="btn btn-success btn-lg btn-block"
              >
                SECCA website
              </a>
            </div>
            <div class="col-md-6">
              <button
                type="button"
                class="btn btn-danger btn-lg btn-block"
                @click="$emit('close')"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
module.exports = {
  name: 'About'
}
</script>
